import { IAuditTrail } from "../../interfaces/domain";
import axios from "../../axios";
import { ActionTypes } from "./actionTypes";

import { IAppState, IAuditTrailAction } from "../../interfaces";
import { ThunkAction } from "redux-thunk";
import { TDispatch } from "../..";

const apiPath = '/json/audittrails';

const listAuditTrailsStart = (): IAuditTrailAction => {
  return {
    type: ActionTypes.AUDIT_TRAIL_LIST_START,
  };
};

const listAuditTrailsSuccess = (auditTrails: Array<IAuditTrail>): IAuditTrailAction => {
  return {
    type: ActionTypes.AUDIT_TRAIL_LIST_SUCCESS,
    auditTrails,
  };
};

const listAuditTrailsFail = (error: string): IAuditTrailAction => {
  return {
    type: ActionTypes.AUDIT_TRAIL_LIST_FAIL,
    error,
  };
};

type TListAuditTrailPromise = Promise<IAuditTrail[] | null>;
type TListAuditTrailAction = ThunkAction<
  TListAuditTrailPromise,
  IAppState,
  any,
  IAuditTrailAction
>;

export interface IAuditTrailSearchOptions {
  operatorId?: string;
  serviceProviderId?: string;
  event?: string;
  createdStart?: string;
  createdEnd?: string;
}

export const listAuditTrails = (options?: IAuditTrailSearchOptions): TListAuditTrailAction => (
  dispatch: TDispatch
): TListAuditTrailPromise => {
  dispatch(listAuditTrailsStart());
  return axios
    .post(`${apiPath}/list`, options)
    .then((res) => {
      const data = Array.isArray(res.data) ? res.data : [];
      dispatch(listAuditTrailsSuccess(data));
      return Promise.resolve(data);
    })
    .catch((err) => {
      const errorMsg = err?.response?.data || err?.message || 'Virhe ladattaessa audit trail -tapahtumia';
      dispatch(listAuditTrailsFail(errorMsg));
      return Promise.resolve(null);
    });
};

export const clearAuditTrails = () => {
  return {
    type: ActionTypes.AUDIT_TRAIL_LIST_CLEAR,
  };
};
